export default __webpack_public_path__ + "static/seroja-commissioner-press-conference-4b7d76c9298a3c36c61519c075cbc4f1.jpg";